import React from "react";

const STATS = [
  { value: "10K+", label: "Fans on Eventom" },
  { value: "24", label: "Cities live" },
  { value: "500+", label: "Events hosted" },
  { value: "150+", label: "Partners & brands" },
];

/**
 * StatsRibbon — quiet editorial social proof.
 * No coloured icons, no gradient chips.  Two typographic sizes only.
 */
export default function StatsRibbon() {
  return (
    <section className="border-t border-b border-line" data-testid="stats-ribbon">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 md:py-10">
        <div className="grid grid-cols-2 md:grid-cols-4">
          {STATS.map((s, i) => (
            <div key={s.label} data-testid={`stat-${i}`}
              className={`px-4 py-4 md:py-2 flex md:flex-col items-baseline md:items-start gap-3 md:gap-1 ${i > 0 ? "md:border-l border-line" : ""}`}>
              <div className="font-fancy text-4xl md:text-5xl leading-none tracking-tight text-text">{s.value}</div>
              <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-muted">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
